import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Image from "../../components/atoms/image";
import {
  BackArrowWrapper,
  BackHomeLabel,
  GoBackWrapper,
  HeaderWrapper,
  LogoWrapper,
  SelectedDeliveryOptionText,
  StartOverContainer,
  StartOverLabelText,
  ToggleButtonContainer,
  ToggleButtonLabelText,
  ToggleButtonWrapper,
} from "./style";

import { KIOSK_DETAILS } from "utils/Constants";
import moment from "utils/momentWrapper";
import FSTRLogo from "../../assets/logo/headerLogo.png";
import Button from "../../components/atoms/button";
import Text from "../../components/atoms/text";
import config from "../../config/config";
import { hideDelSelectionPostStart } from "../../config/envConfig";
import { CartContext } from "../../context/cartContext";
import { DeliveryOptionContext } from "../../context/deliveryOptionContext";
import { FoodTypeContext } from "../../context/foodTypeContext";
import { UserContext } from "../../context/userContext";
import { showDeliveryOption } from "../../utils/helperFunctions";
import { ArrowLeftIcon } from "../../utils/iconList";
import {
  getLocalStorage,
  removeLocalStorage,
  removeSessionStorage,
} from "../../utils/storageUtil";
import GateSelectionModal from "../gateSelectionModal/gateSelectionModal";
import styles from "./style.module.css";
import apiList from "services/apiList";
import { callApi } from "services/callApi";
import { useNav } from "context/navContext";
import { cancelCheckout } from "utils/checkoutKey";

function Header(props) {
  const useUser = useContext(UserContext);
  const useDelivery = useContext(DeliveryOptionContext);
  const useCart = useContext(CartContext);
  const useFoodType = useContext(FoodTypeContext);
  const history = useHistory();
  const { setAccessibilityMode } = useNav();
  const [delOpt, setDelOpt] = useState(0);
  const [openGateModal, setOpenSelectModal] = useState(false);
  const [isEmpSignedin, setIsEmpSignedin] = useState(
    getLocalStorage("EmpData")
  );

  const [loading, setLoading] = useState(true);
  const [navbar, setNavbar] = useState();

  useEffect(() => {
    if (Object.keys(useDelivery.selectedDeliveryOption).length > 0) {
      if (
        useDelivery.selectedDeliveryOption.deliveryOption === "collect at gate"
      ) {
        setDelOpt(1);
      } else {
        setDelOpt(0);
      }
    }
  });

  useEffect(() => {
    fetchNavBar();
  }, []);

  const handleModalOpen = () => {
    setOpenSelectModal(true);
  };

  const handleModalClose = () => {
    setOpenSelectModal(false);
  };

  const onTakeawayClick = () => {
    let selectedDeliveryOption = {
      deliveryOption: config.deliveryOptions.takeaway,
      deliveryAddress: "",
      deliveryTime: moment(new Date(), "UTC", "UTC").format(),
      isPackagingRequested: true,
    };
    useDelivery.handleDeliverySelection(selectedDeliveryOption);
    useCart.updateDeliveryOptions(selectedDeliveryOption);
    setDelOpt(0);
  };

  const onDeliveryClick = () => {
    setDelOpt(1);
    handleModalOpen();
  };

  const handleBackHome = () => {
    const kioskDetails = getLocalStorage(KIOSK_DETAILS);
    if (kioskDetails) {
      const multiMerchantAllowed = kioskDetails?.multiMerchantAllowed;
      if (!multiMerchantAllowed) {
        history.goBack();
        return;
      }
    }
    history.goBack();
  };

  const handleStartOver = async () => {
    removeSessionStorage("isAgeDeclared");
    removeSessionStorage("paymentContent");

    await cancelCheckout(null, "start over");
    await useUser.onLogout();
    useCart.reset();
    useDelivery.resetDeliverySelection();
    useFoodType.resetFoodType();
    setAccessibilityMode(false);
    window.location.replace("/");
  };

  const handleSettings = () => {
    history.push({ pathname: "/empSignIn" });
  };

  const handleEmpSignout = () => {
    setIsEmpSignedin(false);
    removeLocalStorage("EmpData");
  };

  const fetchNavBar = async () => {
    setLoading(true);
    try {
      const apiUrl = apiList.navbar;
      let apiResponse = await callApi.get(apiUrl);
      if (apiResponse?.length > 0) {
        setNavbar(apiResponse?.[0]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const headerLogo = navbar?.darkLogo;

  return (
    <HeaderWrapper
      style={{
        justifyContent:
          props?.hideLogoAndGoBack && props?.hideStartOver
            ? "center"
            : props?.hideLogoAndGoBack
              ? "flex-end"
              : "space-between",
        // backgroundColor: navbar?.bgcolor,
        ...props.style,
      }}
    >
      {props.hideLogoAndGoBack ? null : props.isHomepage ? (
        <LogoWrapper>
          <Image src={FSTRLogo} />
        </LogoWrapper>
      ) : (
        <GoBackWrapper onClick={handleBackHome}>
          <BackArrowWrapper>
            <ArrowLeftIcon
              // src={ArrowLeft}
              style={{
                height: "100%",
                width: "100%",
                color: "var(--header-foreground, var(--primary-foreground))",
              }}
            />
          </BackArrowWrapper>
          <BackHomeLabel>
            <Text>Go Back</Text>
          </BackHomeLabel>
        </GoBackWrapper>
      )}
      {!loading &&
        !props.hideDeliveryAndLogo &&
        (headerLogo?.url ? (
          <Image
            src={headerLogo?.url}
            style={{
              width: headerLogo?.width * 1.7,
              height: headerLogo?.height * 1.7,
            }}
          />
        ) : (
          <SelectedDeliveryOptionText>
            <Text fontFamily="var(--font-secondary)">
              {useDelivery.selectedDeliveryOption?.deliveryOption ===
              config.deliveryOptions.deliveryAtGate
                ? "Delivery"
                : "Order Now"}
            </Text>
          </SelectedDeliveryOptionText>
        ))}
      <StartOverContainer>
        {props.hideStartOver ? null : (
          <Button
            onClick={handleStartOver}
            style={{
              backgroundColor: "transparent",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <StartOverLabelText>
              <Text>Start Over</Text>
            </StartOverLabelText>
          </Button>
        )}
      </StartOverContainer>
      <GateSelectionModal
        open={openGateModal}
        handleClose={handleModalClose}
        handleSubmit={handleModalClose}
      />
    </HeaderWrapper>
  );
}

export default Header;
